import "../styles/general.css";

import axios from "axios";
import BlueLoader from "../components/loader/BlueLoader";
import DesktopView from "../components/desktopview/DesktopView";

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import useRequestHeader from "../hooks/useRequestHeader";

export default function Splash() {
  let TimeSplash = 4200;
  const BASE_URL = process.env.REACT_APP_ROOT_API_ADDRESS;

  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies([]);
  const requestHeader = useRequestHeader();

  const [timreCount, setTimreCount] = useState(0);
  const [timreBol, setTimreBol] = useState(true);

  function NavigatePage(PangeURL) {
    let TimeOut = TimeSplash - timreCount * 500;
    setTimreBol(false);
    if (TimeOut < 800) {
      TimeOut = 800;
    }
    setTimeout(() => {
      let img = document.getElementById("logo");
      img.classList.remove("btFadeIn-delay");
      img.classList.add("btFadeOut-delay");

      let div = document.getElementById("Back-div");
      div.classList.add("btCircle-2");
    }, TimeOut - 800);
    setTimeout(() => {
      navigate(`${PangeURL}`);
    }, TimeOut);
  }

  useEffect(() => {
    if (window.innerWidth < 1024) {
      if (cookies?.utt) {
        let Timer = setInterval(() => {
          if (timreBol) {
            setTimreCount((prev) => prev + 1);
          } else {
            clearInterval(Timer);
          }
        }, 500);
        const config = {
          headers: requestHeader,
        };
        axios
          .post(`${BASE_URL}/user/status`, {}, config)
          .then((res) => {
            if (res?.data?.Error) {
              NavigatePage("/add-car");
            }
            if (res?.data?.Data?.defaultCar) {
              if (res?.data?.Data?.defaultPlate) {
                setCookies("plate", res?.data?.Data?.defaultPlate, {
                  path: "/",
                });
                for (const item in cookies) {
                  if (
                    item !== "plate" &&
                    item !== "user" &&
                    item !== "utt" &&
                    item !== "slider"
                  ) {
                    removeCookies(item);
                  }
                }
                NavigatePage("/short-terms");
              } else {
                NavigatePage("/add-car");
              }
            } else {
              NavigatePage("/add-car");
            }
          })
          .catch((err) => {
            NavigatePage("/add-car");
          });
      } else {
        if (!cookies?.slider) {
          NavigatePage("/slider");
        } else {
          NavigatePage("/login");
        }
      }
    }
  }, []);

  return (
    <>
      <div className="hidden min-[1024px]:block">
        <DesktopView />
      </div>
      <div className="w-full h-screen flex items-center justify-center bg-color-primary-B min-[1024px]:hidden">
        <img
          src="../assets/icons/512-transparent.png"
          id="logo"
          className="w-[30vw] h-[30vw] z-[10] btFadeIn-delay"
          alt="Scarpin LOGO"
        />
        <div className=" fixed w-[0] h-[0] flex items-center justify-center rounded-[50%] bg-[#02161D] z-[8] btCircle"></div>
        <div
          id="Back-div"
          className=" fixed w-[0] h-[0] flex items-center justify-center rounded-[50%] bg-[#02161D] z-[8]"
        ></div>
        <div className="absolute bottom-[5vw] flex flex-col items-center justify-center z-[10] text-[#FFF]">
          <div className="w-full flex justify-center items-center py-[2.5vw] opacity-0 btFadeIn">
            <BlueLoader
              width={10}
              top={0}
              zIndex={100}
              right={0}
              position={"relative"}
            />
          </div>
          <p className="w-full text-center font-font_primary_A text-[2.5vw] text-[#474747] font-bold opacity-0 btFadeIn">
            نسخه: <span>{process.env.REACT_APP_VERSION}</span>
          </p>
        </div>
      </div>
    </>
  );
}
